import React, { useContext } from 'react';

import { Props } from './DetailsInfo.types';
import { Styled } from './DetailsInfo.styles';
import { mapContext } from '../mapContext';
import { MapPopup } from '../MapPopup';
import { DetailsInfoType } from '../MapPage.types';
import { VehicleDetails } from './VehicleDetails';
import { RouteDetails } from './RouteDetails';
import { StopDetails } from './StopDetails';
import { AgencyInfo } from './AgencyInfo';
import { BCRegions } from './BCRegions';

const DetailsInfoBody: React.FC = () => {
  const { detailsInfo } = useContext(mapContext);

  switch (detailsInfo?.type) {
    case DetailsInfoType.vehicle:
      return <VehicleDetails id={detailsInfo.id} />;

    case DetailsInfoType.stop:
      return <StopDetails id={detailsInfo.id} />;
    case DetailsInfoType.route:
      return <RouteDetails id={detailsInfo.id} />;
    case DetailsInfoType.agency:
    case DetailsInfoType.department:
    case DetailsInfoType.depot:
      return <AgencyInfo type={detailsInfo.type} id={detailsInfo.id} />;
    case DetailsInfoType.bcregions:
      return <BCRegions id={detailsInfo.id} />;
  }
  return null;
};

export const DetailsInfo: React.FC = () => {
  const { setDetailsInfo, detailsInfo } = useContext(mapContext);

  if (!detailsInfo) return null;

  let label;

  switch (detailsInfo.type) {
    case DetailsInfoType.vehicle:
      label = 'ТС';
      break;
    case DetailsInfoType.agency:
      label = 'Предприятие';
      break;
    case DetailsInfoType.route:
      label = 'Маршрут';
      break;
    case DetailsInfoType.stop:
      label = 'Остановка';
      break;
    case DetailsInfoType.department:
      label = 'Территориальный отдел';
      break;
    case DetailsInfoType.depot:
      label = 'Филиал';
      break;
    case DetailsInfoType.bcregions:
      label = 'Районы контроля';
      break;
  }

  return (
    <MapPopup label={label} onClose={() => setDetailsInfo(null)}>
      <DetailsInfoBody />
    </MapPopup>
  );
};
